import BaseSingleton from '../../../base/base_singleton';
import BaseObject from '../../../base/base_object';
import Event from '../../../utils/event';
import {SYSTEM_EVENTS} from '../../../events/events';
import {isCancelGameFlowResponse} from "../game_steps/game_step_base";


/**
 * The reason for Runner class is to make sure that nobody will call the same sequence twice.
 * A game sequence instance can only run once.
 */
class Runner extends BaseObject {
    static CLASS = "Runner";

    _serviceFactory = null;

    init(params) {
        super.init(params);
        this._steps = params.steps || [];
        this._serviceFactory = params.serviceFactory;
    }

    run(gameOptions) {
        if(this._steps.length === 0) {
            return Promise.resolve(gameOptions);
        }

        let step = this._steps.shift();
        return step.run(gameOptions)
            .then(gameOptions => this.run(gameOptions))
            .catch((err) => {
                if (!err) {
                    this._serviceFactory
                        .structuredLoggingService()
                        .getLogger()
                        .addCategory('game_service_sequence_runner')
                        .addAction('undefined_error')
                        .addValue(step.getClassName())
                        .error();

                } else if (!isCancelGameFlowResponse(err)) {
                    this.logger.debug(`Game step ${step.getClassName()} failed!`, err);
                    err.failedGameStep = step.getClassName();
                }

                throw err;
            });
    }
}


export default class GameServiceSequenceRunner extends BaseSingleton {
    static CLASS = 'GameServiceSequenceRunner';
    _serviceFactory = null;

    init(params) {
        super.init(params);
        this._subscribe();
        this._serviceFactory = params.serviceFactory;

    }

    _subscribe() {
        Event.on(SYSTEM_EVENTS.OAUTH_STATE_CHANGE, () => {
            this._sequenceInProgress = false;
        }, this);
    }

    _sequenceInProgress = false;
    run(gameOptions, steps) {
        if (this._sequenceInProgress) {
            this.logger.warn('There is already a game sequence in progress');
            return Promise.reject();
        }


        let runner = Runner.create({
            steps: steps,
            serviceFactory: this._serviceFactory
        });

        try {
            this._sequenceInProgress = true;

            return runner.run(gameOptions)
                .then((result) => {
                    this._sequenceInProgress = false;
                    Event.fire(SYSTEM_EVENTS.GAME_SEQUENCE_FINISH, true);
                    return result;
                })
                .catch(err => {
                    this._sequenceInProgress = false;
                    Event.fire(SYSTEM_EVENTS.GAME_SEQUENCE_FINISH, false);
                    this.reThrowError('94', 'Game sequence failed!', err, {gameOptions});
                });
        }
        catch(err) {
            this._sequenceInProgress = false;
            Event.fire(SYSTEM_EVENTS.GAME_SEQUENCE_FINISH, false);
            this.reThrowError('100', 'Game sequence failed!', err, {gameOptions});
        }
    }
}
